import { useEffect, useState, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchRobinhoodFresh, fetchRobinhoodWallets } from "./api";
import { getClientId } from "./clientId";

const SEEN_KEY = "alphaapeing_robinhood_seen";

export const getRobinhoodSeen = () => {
  try { return new Set(JSON.parse(localStorage.getItem(SEEN_KEY) || "[]")); } catch { return new Set(); }
};

export const markRobinhoodSeen = (addrs) => {
  localStorage.setItem(SEEN_KEY, JSON.stringify(addrs || []));
  window.dispatchEvent(new Event("robinhood-seen-updated"));
};

export const useRobinhoodAlerts = () => {
  const cid = getClientId();
  const q = useQuery({
    queryKey: ["robinhoodFresh"],
    queryFn: fetchRobinhoodFresh,
    refetchInterval: 90000,
    staleTime: 60000,
  });
  const wq = useQuery({
    queryKey: ["rhWallets", cid],
    queryFn: () => fetchRobinhoodWallets(cid),
    refetchInterval: 90000,
    staleTime: 60000,
  });
  const addrs = useMemo(() => {
    const out = (q.data?.tokens || []).map((t) => t.address).filter(Boolean);
    for (const w of wq.data?.wallets || []) for (const t of w.recent || []) if (t.address) out.push(t.address);
    return out;
  }, [q.data, wq.data]);

  const [seen, setSeen] = useState(getRobinhoodSeen);
  useEffect(() => {
    const h = () => setSeen(getRobinhoodSeen());
    window.addEventListener("robinhood-seen-updated", h);
    return () => window.removeEventListener("robinhood-seen-updated", h);
  }, []);

  const newCount = addrs.filter((a) => !seen.has(a)).length;
  return { newCount, addrs };
};
